export default "__VITE_ASSET__BRNonmah__"